
function Logo() {
    return <img src="/logo-D9zUGfd5.png" alt="Logo" />;
}
export default Logo;